import React from "react";

const PageNotFound = () => {
  return (
    <div>
      <h1>Page not found 404 err</h1>
    </div>
  );
};

export default PageNotFound;
